<app-page-title
	title="Contato"
	subtitle="Fale Conosco"
	breadcrumb="Contato"
	subpage="Sobre"
	(subpageClick)="goAbout()"
	/>

<section class="page-section">
	<div class="contact-container container relative flex flex-column md:flex-row gap-4">
		<div class="col flex contact-summary flex-column">
			<h4>Lembrando...</h4>
			<p>
				Antes de enviar dúvidas ou contestações em relação ao sistema de pontuação, certifique-se que você leu o <a (click)="goRules()">Regulamento</a>.
			</p>
			<p>
				É sempre bom lembrar que sua lista só é válida um mês após o envio da mesma e que não é possível alterá-la ou excluí-la.
			</p>
			<p>
				Se alguma morte não consta no site é porque ela não foi considerada relevante o suficiente para ser adicionada no bolão. Se você discorda, boa sorte em tentar nos convencer o contrário – às vezes funciona, mas use argumentos fortes para relembrar-nos da importância do defunto.<br/>
				O prazo para adicionarmos um novo presunto é de um mês após a morte do cidadão. Não é possível contabilizarmos a pontuação de defuntos após o corpo ter esfriado tanto.<br/>
				Se o presunto for fresco demais, dê-nos ao menos uma semana para atualizar o sistema antes de enviar uma reclamação. Ao contário do que pode parecer, não vivemos de fazer bolão de pessoas mortas, então temos nossos próprios empregos (e vidas) para cuidar.<br/>
				Confira também se o falecido <a (click)="goRulesCeb()">é uma celebridade válida</a>.
			</p>
			<p>
				Acusações de mau-gosto, ameaças de processo, xingamentos e demais ofensas são bem-vindas. Mande-nos para que possamos rir de você.
			</p>
		</div>
		<div class="col contact-form">
			<app-contact-form />
			<app-block-350-300 />
		</div>
	</div>
</section>
